@if (isLoaded) {
  <section>
    <i-title [text]="'createCourrier.documentTemplates' | translate" level="1"></i-title>
    <span class="tips d-flex text-justify">
      {{ 'createCourrier.selectTemplatePrompt' | translate }}
    </span>
    <div class="tChoice mt-1">
      @if (templates?.length > 0) {
        <div>
          <i-table
            class="super-table"
            id="templatesChoice4"
            height="calc( 100vh - 160px)"
            [paginator]="true"
            [columns]="columns"
            [items]="templates"
            [multiselect]="false"
            [totalRecords]="documentTemplatePagedResult.totalCount"
            [rows]="documentTemplatePagedResult.pageSize"
            [firstPage]="0"
            [lazy]="true"
            (onPageChange)="lazyLoadData($event)"
            (onClickRow)="onTemplateSelect($event)"></i-table>
        </div>
      }
    </div>
  </section>
}
@if (!isLoaded) {
  <div class="loader_div">
    <i-loader [size]="100" [text]="'loading' | translate"></i-loader>
  </div>
}
